import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-mist px-4 py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-136" data-mp="2z5bcytzifl9f">
      <div className="mx-auto max-w-3xl" data-id="element-137" data-mp="3mtl5sfv559a2">
        <SectionHeading id="faq-title" data-id="element-138" data-mp="3rrmnawcx50jf">Frequently asked questions</SectionHeading>

        <div className="mt-10 space-y-3" data-id="element-139" data-mp="3rtqtjkyaibmv">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/10" data-id="element-140" data-mp="3i1bbknmztn1z" data-mpi={i}>
                <h3 data-id="element-141" data-mp="9l8aj0qdywmm">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-base font-extrabold text-navy-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent-500 sm:text-lg" data-id="element-142" data-mp="9kq9lqss3u8d">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-accent-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-143" data-mp="25o8g0xzn69wj" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-144" data-mp="2te2rbb4bbqeo">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-145" data-mp="2ohcf4yvmpeyj">
                      <p className="px-5 pb-5 text-base leading-relaxed text-ink/75" data-id="element-146" data-mp="1jsrzlbbnxg3c">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCTA label="All clear — get my blueprint" data-id="element-147" data-mp="1xqgm0nldovai" />
      </div>
    </section>;
}